import type { Method } from 'lib/axios';

import { APICallV4 } from '../APICall';

export type AiImprovePathType = 'file' | 'public' | 'attach';

interface RequestData {
    task_id: string;
}

export class ImproveImageApiCall extends APICallV4<ArrayBuffer, RequestData> {
    _method = 'improve/image/download';
    _type: Method = 'get';
    _responseType = 'arraybuffer' as const;
}

export const improveImageApiDownloadCall = (args: RequestData) => new ImproveImageApiCall().makeRequest(args);
